import classNames from 'classnames';
import { ButtonHTMLAttributes, DetailedHTMLProps, ForwardedRef, forwardRef } from 'react';
import LoadingIndicator from '../LoadingIndicator';
import './style.scss';

type ButtonProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & {
  secondary?: boolean;
  isLoading?: boolean;
  ref?: ForwardedRef<HTMLButtonElement>;
};

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ className, secondary, isLoading, ...props }, ref) => (
  <button
    className={classNames(
      'button',
      { 'button--secondary': secondary, 'button--loading': isLoading, 'button--disabled': props.disabled },
      className
    )}
    ref={ref}
    {...props}
  >
    {isLoading ? <LoadingIndicator /> : <div className="button__content">{props.children}</div>}
  </button>
));

export default Button;
